//
export default [
	{
		name: 'file',
		type: 'text-field',
		flex: {
			xs12: true,
		},
		props: {
			accept: ".xls,.xlsx",
			height: 64,
			label: 'Archivo',
			name: 'file',
			outline: false,
			solo: true,
			type: 'file',
		},
	}
]